/**
 * Zzzing Admin API
 * Zzzing Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: ci@zzzing.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface WithdrawnReservationsAnalysis { 
    sales_channel_name?: string;
    sales_channel_id?: string;
    /**
     * the total number of withdrawn reservations
     */
    count_withdrawn?: number;
}

